// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__V-zd1","file":"styles_file__Cvp7I"};